import { virtualColor, type ExtendedColor } from '@/theme/themeHelpers';
import { ActionIcon, createTheme, type MantineColorsTuple, type MantineThemeOverride } from '@mantine/core';

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendedColor, MantineColorsTuple>;
  }
}

const theme: MantineThemeOverride = createTheme({
  black: '#333',

  colors: {
    dark: ['#c9c9c9', '#5D5F6B', '#52545E', '#474952', '#3C3D45', '#313238', '#26272B', '#1A1B1E', '#16171A', '#121315'],
    white: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#F9F9FB', '#f1f3f5'],
    ...virtualColor('primary', 'cyan', 'cyan'),
    ...virtualColor('paper', 'white', 'dark'),
    ...virtualColor('selection', 'gray', 'dark'),
  },

  autoContrast: true,
  primaryColor: 'primary',
  primaryShade: 9,

  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji',

  breakpoints: {
    xs: '30em',
    sm: '48em',
    md: '64em',
    lg: '74em',
    xl: '90em',
  },

  defaultRadius: 'md',

  components: {
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        variant: 'transparent',
        color: 'inherit',
      },
    }),
  },
});

export const appShellHeaderHeight = 60;

export default theme;
